import { TXTWCL_Please_enter_a_valid_postcode__ELL } from './postalCode.messages.json';

export const maxLength = 10;
export const minLength = 3;

const patterns = {
  AU: '^((ACT|NSW|NT|QLD|SA|TAS|VIC|WA) )?\\d{4}$',
  DE: '^\\d{5}$',
  RU: '^[1-9]\\d{5}$',
  BE: '^\\d{4}$',
  CA: '^[A-Z]\\d[A-Z] ?\\d[A-Z]\\d$',
  DK: '^\\d{4}$',
  ES: '^\\d{5}$',
  FR: '^(\\d{2}|2A|2B)\\d{3}$',
  GB: /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i,
  IT: '^\\d{5}$',
  US: '^\\d{5}(-\\d{4})?$',
  PT: '^[1-9]\\d{3}-\\d{3}$',
  BG: '^\\d{4}$',
  RO: '^\\d{6}$',
  CZ: '^\\d{6}$'
};

export const postalCode = (country: string) => (value: string) => {
  const pattern = patterns[country];
  const valid =
    !!value &&
    (pattern
      ? new RegExp(pattern).test(value.toUpperCase())
      : value.length >= minLength && value.length <= maxLength);

  return { valid, message: TXTWCL_Please_enter_a_valid_postcode__ELL };
};
